import { useEffect, useState } from "react";
import { AnalogsSchema, getAnalogs } from "src/models/newProduct/getAnalogs";
import { useRouter } from "next/router";

export const useGetAnalogs = () => {
  const [analogs, setAnalogs] = useState<AnalogsSchema>();
  const [isLoadingAnalogs, setLoadingAnalogs] = useState(false);

  const router = useRouter();
  const citySlug = router.query.city;
  const productSlug = router.query.product;

  useEffect(() => {
    setLoadingAnalogs(true);
    if (typeof citySlug === "string" && typeof productSlug === "string") {
      getAnalogs({
        product_slug: productSlug,
        city_slug: citySlug,
      })
        .then((res) => setAnalogs(res.data))
        .catch(() => console.log("error"))
        .finally(() => setLoadingAnalogs(false));
    }
  }, [citySlug, productSlug]);

  return { analogs, isLoadingAnalogs };
};
